import { FASTListboxOption as s, listboxOptionTemplate as c } from "@matrix42/fast-foundation";
import { listboxOptionStyles as l } from "./listbox-option.styles.js";
import { Icon as h } from "../../icon/index.js";
import { Checkbox as o } from "../../checkbox/index.js";
const t = class t extends s {
  constructor() {
    super(...arguments), this._selectedIndicator = new h("check"), this._checkbox = new o();
  }
  //TODO on multipleChange, add/remove checkbox
  get multiple() {
    var e;
    return ((e = this.parentElement) == null ? void 0 : e.multiple) ?? !1;
  }
  selectedChanged() {
    var e;
    super.selectedChanged(), this.multiple ? this._checkbox && (this._checkbox.checked = this.selected) : this.selected ? this.insertBefore(this._selectedIndicator, this.firstChild) : (e = this._selectedIndicator) != null && e.parentElement && this.removeChild(this._selectedIndicator);
  }
  //TODO refactor to use start & end option of template
  connectedCallback() {
    super.connectedCallback(), this._checkbox.setAttribute("slot", "start"), this._selectedIndicator.classList.add("selected-indicator"), this._selectedIndicator.setAttribute("slot", "end"), this.multiple && this.insertBefore(this._checkbox, this.firstChild), this.selected && !this.multiple && this.insertBefore(this._selectedIndicator, this.firstChild);
  }
};
t.definition = {
  name: "listbox-option",
  template: () => c(),
  styles: l
};
let i = t;
export {
  i as ListboxOption
};
